export const MAX_SCALE = 120;
export const MAX_UPLOAD_SIZE = 536870912;

export default {
  MAX_SCALE,
  MAX_UPLOAD_SIZE,
}
